module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C1166"
  }, [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents ")])]), _vm._v(" "), _c('p', {
    staticClass: "C1157"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/05_Acknowle#page_ix"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1164"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/06_Introduc#page_1"
    }
  }, [_vm._v("Introduction: Fat, Gay, Christian")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1161"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_PART_ONE#page_17"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")])]), _vm._v("Framing Right and Wrong")])]), _vm._v(" "), _c('p', {
    staticClass: "C1162"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_1_Sin#page_19"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("1")]), _c('em', [_vm._v("Sin ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1163"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_2_Health#page_52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("2")]), _c('em', [_vm._v("Health ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1161"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_PART_TWO#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART TWO")])]), _vm._v("Making Christian Bodies")])]), _vm._v(" "), _c('p', {
    staticClass: "C1162"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_3_Change#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("3")]), _c('em', [_vm._v("Change, in Theory ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1163"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_4_Change#page_110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("4")]), _c('em', [_vm._v("Change, in Practice ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1161"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_PART_THR#page_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART THREE")])]), _vm._v("Accountings")])]), _vm._v(" "), _c('p', {
    staticClass: "C1162"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_5_Succes#page_155",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("5")]), _c('em', [_vm._v("Success/Failure ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1163"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_6_Breaki#page_194",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_vm._v("6")]), _c('em', [_vm._v("Breaking ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1132"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/16_Conclusi#page_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Judgment—Religious and Secular")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1164"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/17_Notes#page_231",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1164"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/18_Bibliogr#page_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "C1164"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/19_Index#page_283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73961686","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 66
// module chunks = 0